module.exports = __webpack_public_path__ + "static/Rumsha.158cd7fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Rumsha.jpg
// module id = 1320
// module chunks = 137408898365125